import { APIRoute } from '@/modules/utils'
import { HydraSearchParams, IRI } from 'emt-library'
import { Conversation } from '@/dataV3/Conversation/Conversation'

export const Route = (path: IRI): APIRoute => ({
  method: 'GET',
  path,
})

export type SearchParams = HydraSearchParams

export type Response = Conversation
